import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from '../../axios/requests';
import API from '../../constant.api';

export type LedgerEmailStatus = 'active' | 'deactive';

export interface LedgerEmailEntry {
  email: string;
  status: LedgerEmailStatus;
  // the email the organization signed up with; changing or removing it needs an OTP to a new email
  isAccountEmail: boolean;
}

export interface LedgerEmailsResponse {
  organizationName?: string;
  emails: LedgerEmailEntry[];
}

export interface LedgerEmailsChangeResponse {
  message: string;
  emails: LedgerEmailEntry[];
}

export interface LedgerEmailOtpResponse {
  message: string;
  email: string; // masked
  expiresInSeconds: number;
  resendAfterSeconds: number;
}

// Superadmin only. requests.ts attaches the Bearer token.
const enc = encodeURIComponent;

export const fetchLedgerEmails = async (): Promise<LedgerEmailsResponse> => {
  const { data } = await getRequest(API.LEDGER_EMAILS, {});
  return data;
};

export const setLedgerEmailStatus = async (
  email: string,
  status: LedgerEmailStatus
): Promise<LedgerEmailsChangeResponse> => {
  const { data } = await putRequest(
    `${API.LEDGER_EMAILS}/${enc(email)}/status`,
    {
      status,
    }
  );
  return data;
};

export const removeLedgerEmail = async (
  email: string
): Promise<LedgerEmailsChangeResponse> => {
  const { data } = await deleteRequest(`${API.LEDGER_EMAILS}/${enc(email)}`);
  return data;
};

// Add (or edit) an email: the OTP goes to the NEW address and nothing is saved until verify succeeds.
// For an edit, pass the address being replaced as replaceEmail.
export const sendLedgerEmailOtp = async (payload: {
  email: string;
  replaceEmail?: string;
}): Promise<LedgerEmailOtpResponse> => {
  const { data } = await postRequest(`${API.LEDGER_EMAILS}/send-otp`, payload);
  return data;
};

export const verifyLedgerEmail = async (payload: {
  email: string;
  otp: string;
}): Promise<LedgerEmailsChangeResponse> => {
  const { data } = await postRequest(`${API.LEDGER_EMAILS}/verify`, payload);
  return data;
};
